<script>
  import { onMount } from 'svelte'
  import { tweened } from 'svelte/motion'
  import { quintInOut } from 'svelte/easing'

  /**
   * This component's job is to animate between min and value, on a scale of 0 to 100.
   * It is meant to be used alongside other selves.
   */
  export let value = 0
  export let label
  // export let min = 0
  export let max = 100
  // base, red, gray
  export let variant = 'base'
  export let rotate = false
  export let prefix = ''
  export let suffix = ''
  export let isDecorative = false
  export let index // parent component should set this as it loops

  export let animationDuration = 2000
  export let animationDelay = 150

  const displayPercent = tweened(0, {
    delay: animationDelay,
		duration: animationDuration,
		easing: quintInOut
	})
  let computedPercent = (value / max) * 100
  // $: console.log('computedPercent', computedPercent)
  // $: console.log('value', value)
  // $: console.log('max', max)
  // $: if(variant == 'gray' ){console.log('displayPercent', $displayPercent)}

  onMount(()=>{
    if(!isDecorative) {
      $displayPercent = computedPercent
    } else if(index == 0) {
      $displayPercent = 85
    } else {
      $displayPercent = 100
    }
  })
  
</script>

<div class="fundip-stick { variant }-variant{ rotate ? ' rotate' : '' }{ isDecorative ? ' decorative' : ''}">
  { #if !isDecorative }<p class="label">{ label }</p>{ /if }
  <div class="outer">
    <div class="inner" style="{rotate ? 'min-width' : 'min-height'}: { $displayPercent }%;">
      <p class="inner-label">{ #if isDecorative }{ label }{ /if } { prefix }{ value.toLocaleString("en-US") }{ suffix }</p>
    </div>
  </div>
</div>

<style lang="scss">
  .fundip-stick {
    --thickness: 8rem;
    --less-thickness: 6rem;
    
    width: var(--thickness);
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: center;
    flex-basis: 25%;
  }

  .fundip-stick.rotate {
    flex-direction: column;
    width: 100%;
    padding: 0.5rem;
  }

  .fundip-stick.rotate .inner {
    height: var(--less-thickness);
  }

  .fundip-stick.base-variant .inner {
    color: #333;
    background-color: #FFF;
  }

  .fundip-stick.red-variant .inner {
    color: #FFF;
    background-color: #e00122;
  }

  .fundip-stick.gray-variant .inner {
    color: #FFF;
    background-color: #848485;
  }
  
  .fundip-stick > p {
    text-align: center;
    padding: 0.5rem;
    height: 5rem;
    font-size: 2rem;
    font-weight: 400;
    text-transform: uppercase;
  }
  .fundip-stick.base-variant > p { color: #FFF; }
  .fundip-stick.red-variant > p { color: #333; }
  .fundip-stick.rotate > p {
    flex-shrink: 1;
    width: 100%;
    height: unset;
    padding: 0.5rem 0.5rem 0 0.5rem;
  }

  .outer {
    /*@apply h-full w-full grow flex items-end;*/
    height: 100%;
    width: 100%;
    display: flex;
    flex-grow: 1;
    align-items: flex-end;
  }

  .inner {
    /*@apply w-full flex flex-row rounded-full shadow-2xl;*/
    width: 100%;
    display: flex;
    flex-direction: row;
    border-radius: 9999px;
    filter: drop-shadow(0.25em 0.25em 0.35em rgba(0, 0, 0, 0.3));

    @media(max-width:1199px) {
      width: min-content;
    }
  }

  .rotate .inner {
    width: unset;
    height: 100%;
    flex-direction: row;
    vertical-align: middle;
  }

  .inner p.inner-label {
    /* @apply mx-auto my-0 py-1 text-center self-center; */
    margin: 0 auto;
    padding: 0 0.25rem;
    text-align: center;
    align-self: center;
  }
  .base-variant .inner p {
    color: #333;
  }
  .rotate .inner p {
    vertical-align: middle;
  }
  .decorative .inner p {
    margin: 0 1rem;
  }
</style>